import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { environment } from "./../../../../environments/environment";
import { FormGroup, FormControl, Validators, FormBuilder } from "@angular/forms";
import { CreateProject, Project } from "src/app/core/interfaces/quoting-tool";
import { QuotingToolService } from "../quoting-tool.service";
import { Router } from "@angular/router";
import { NotificationService } from "src/app/core/services/notification.service";
import { MatRadioChange } from "@angular/material/radio";

@Component({
  selector: "app-create-project",
  templateUrl: "./create-project.component.html"
})
export class CreateProjectComponent implements OnInit {

  @Output() typeChanged = new EventEmitter<number>();

  onTypeChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const selectedValue = Number(inputElement.value);
    this.typeChanged.emit(selectedValue);
  }

  getImagePath: any = environment.image_path;
  createProjectForm!: FormGroup;
  createProjectFormSubmitted = false;
  isFormInvalid: boolean = true;
  isLoading: boolean = false;
  projectOptions: Project[] = [{ id: '1', name: 'PCBA only' },
    // {id: '2', name:'Mechanical only'},{id: '3', name:'Full Product Assembly'}
  ];

  constructor(
    private quotingService: QuotingToolService,
    private router: Router,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
    this.createProjectForm = new FormGroup({
      name: new FormControl("", [Validators.required, Validators.maxLength(100),Validators.pattern('^[A-Za-z0-9][A-Za-z0-9 ]*$')]),
      description: new FormControl("", [Validators.required, Validators.maxLength(1000),Validators.pattern('^\\S.*$')]),
      type: new FormControl(this.projectOptions[0].id, [Validators.required]),
    });
  }

  CheckIfInvalid() {
    if (this.createProjectForm.invalid) {
      this.isFormInvalid = true;
    } else {
      this.isFormInvalid = false;
    }
  }

  CreateProject() {
    this.createProjectForm.markAllAsTouched();
    this.createProjectFormSubmitted = true;

    // Check if the form is invalid
    if (this.createProjectForm.invalid) {
      // Display error messages for all fields
      Object.keys(this.createProjectForm.controls).forEach((field) => {
        const control = this.createProjectForm.get(field);
        if (control) {
          control.markAsDirty({ onlySelf: true });
        }
      });
      return;
    }

    const reqJSON: CreateProject = {
      vProjectName: this.createProjectForm.value.name,
      vDescription: this.createProjectForm.value.description,
      // vProjectType: this.createProjectForm.value.type,
      vProjectType: 1,
      vName: localStorage.getItem("user_name"),
      vEmailId: localStorage.getItem("user_email"),
      vDialCode: localStorage.getItem("user_DialCode"),
      vPhoneNo: localStorage.getItem("user_PhoneNo"),
    };
    // API Call Goes Here
    this.isLoading = true;
    this.quotingService.CreateProject(reqJSON).subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        const projectID = resJSON.data.iProjectID;
        const projectType = resJSON.data.vProjectType;
        const uniqueID = resJSON.data._id;

        // Storing project ID and type in local storage
        localStorage.setItem("projectID", projectID);
        localStorage.setItem("projectType", projectType);
        localStorage.setItem("ID", uniqueID);
        localStorage.setItem('upload_gerber', 'false');
        this.createProjectForm.reset();
        this.notificationService.showSuccess(`${resJSON.message}`, "");
        this.router.navigate(["/m-quotation/stepper-forms"], {
          queryParams: { projectID: projectID },
        });
        this.isLoading = false;
      } else {
        this.isLoading = false;
        this.notificationService.showError(`${resJSON.message}`, "");
      }
    });
  }

  onSelectionChange(event: MatRadioChange) {
    const selectedProjectId = event.value;
  }

  hasError(form: FormGroup, controlName: string, errorName: string): boolean {
    const control = form.get(controlName);
    return !!control?.hasError(errorName) && (!!control?.touched);
  }
}
